import { gsap } from 'gsap';

export default class Intro {
    constructor() {
        this.tl = gsap.timeline();
        // this.init();
    }

    init() {
        // this.introAnm();
    }

    introAnm() {
        const range = window.innerWidth < 768 ? 10 : 20;

        this.tl.fromTo('.mainvisual__fxdcontent', { duration: 1.5, opacity: 0, scale: 1.5 }, { opacity: 1, scale: 1, ease: 'circ.inOut' }, 1);
        this.tl.fromTo('.mainvisual__ph', { duration: 1, opacity: 0, y: 20 }, { opacity: 1, y: 0 }, 1.8);

        this.tl.fromTo('.mainvisual__10thlogo img', { duration: 1, opacity: 0, y: range }, { opacity: 1, y: 0 }, 2.0);
        this.tl.fromTo('.mainvisual__ttl img', { duration: 1, opacity: 0, y: range }, { opacity: 1, y: 0 }, 2.2);
        this.tl.fromTo('.mainvisual__scroll', { duration: 1, opacity: 0 }, { opacity: 1 }, 2.4);
    }
}
